import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePanelStateStore = defineStore('panel-state', () => {
    let currentPanelIndex = ref(0);
    let tabIndex = ref(0);

    let panels = ref([
        {
			parentPanelId: null,
			id: 'base',
			text: 'Filters',
			select: false,
			multiselect: false,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'college',
			text: 'Colleges',
			select: true,
			multiselect: true,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'term',
			text: 'Terms',
			select: true,
			multiselect: false,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'startsOn',
			text: 'Starts In',
			catchAllCategory: 'All Months',
			select: true,
			multiselect: true,
			currentCategory: '0',
			currentCategoryIndex: 0,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'campus',
			text: 'Campus',
			select: true,
			multiselect: true,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'enrollable',
			text: 'Display',
			select: true,
			multiselect: false,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'format',
			text: 'Format',
			select: true,
			multiselect: true,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'days',
			text: 'Days',
			select: true,
			multiselect: true,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'subject',
			text: 'Subject',
			select: true,
			multiselect: true,
			currentIndex: 0,
		},
		{
			parentPanelId: 'base',
			id: 'course',
			text: 'Course',
			catchAllCategory: 'All Courses',
			select: true,
			multiselect: true,
			currentCategory: '0',
			currentCategoryIndex: 0,
			currentIndex: 0,
		},
    ]);

    /**
     * @param {{ id?: string, currentIndex?: number, currentCategory?: string, currentCategoryIndex?: number }} state
     */
    function updatePanelState(state) {
        let panelIndex = state.hasOwnProperty('id')
            ? panels.value.findIndex((item) => item.id === state.id)
            : currentPanelIndex.value;

        if (state.hasOwnProperty('currentIndex')) {
            panels.value[panelIndex].currentIndex = /** @type {number} */ (state.currentIndex);
        }
        if (state.hasOwnProperty('currentCategory')) {
            panels.value[panelIndex].currentCategory = state.currentCategory;
        }
        if (state.hasOwnProperty('currentCategoryIndex')) {
            panels.value[panelIndex].currentCategoryIndex = state.currentCategoryIndex;
        }
    }

    /**
     * @param {string} panelId
     */
    function updateCurrentPanel(panelId) {
        currentPanelIndex.value = panels.value.findIndex((i) => i.id === panelId);
    }

    return {
        currentPanelIndex,
        panels,
        tabIndex,
        updatePanelState,
        updateCurrentPanel,
    };
});
